import Phaser from 'phaser';
import { Card } from './Card';
import {CardConfig, CardSettings} from './CardTypes';
import { Stats } from './Stats';
import { Room } from './Room';

export class CardDeck {
    private scene: Phaser.Scene;
    private cards: Card[] = [];
    private startX: number;
    private y: number;
    private playerStats: Stats;
    private currentRoom: Room | undefined = undefined;
    private isUsingCard: boolean = false;

    constructor(scene: Phaser.Scene, startX: number, y: number, playerStats: Stats) {
        this.scene = scene;
        this.startX = startX;
        this.y = y;
        this.playerStats = playerStats;
    }

    public setCurrentRoom(room: Room): void {
        this.currentRoom = room;
        this.isUsingCard = false;
    }

    public addCard(config: CardConfig): void {
        const card = new Card(this.scene, 0, this.y, config, (card) => this.useCard(card));
        this.cards.push(card);
        this.updateCardPositions();
    }

    private useCard(card: Card): void {
        if (this.isUsingCard || this.currentRoom === undefined || (this.scene as any).getIsLocked()) return;
        
        this.isUsingCard = true;
        card.applyEffect(this.playerStats, this.currentRoom);
        this.removeCard(card);
    }

    private removeCard(card: Card): void {
        const index = this.cards.indexOf(card);
        if (index !== -1) {
            card.destroy();
            this.cards.splice(index, 1);
            this.updateCardPositions();
        }
    }

    private updateCardPositions(): void {
        const totalWidth = (this.cards.length - 1) * (CardSettings.width + CardSettings.spacing);
        const startX = this.startX - totalWidth / 2;

        this.cards.forEach((card, index) => {
            const x = startX + (index * (CardSettings.width + CardSettings.spacing));
            card.updatePosition(x, this.y);
        });
    }

    public getCards(): Card[] {
        return this.cards;
    }

    public clear(): void {
        this.cards.forEach(card => {
            card.destroy();
        });
        this.cards = [];
    }

    public lock() {
        this.cards.forEach((card) => card.lock())
    }

    public unlock() {
        this.cards.forEach((card) => card.unlock())
    }
} 